"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M22.383 12.998a.495.495 0 0 1 .581.27l.03.085.929 3.48a2.194 2.194 0 0 1-1.49 2.679l-.03.011L7.458 23.53a2.177 2.177 0 0 1-1.666-.212c-.44-.25-.77-.636-.952-1.1l-.081-.24-.722-2.712a.501.501 0 0 1 .936-.343l.03.085.712 2.673.018.053c.083.305.28.559.555.716.237.135.509.186.775.143l.133-.03 14.882-3.987.047-.015c.304-.084.559-.284.717-.562.134-.238.184-.508.142-.772l-.028-.131-.93-3.486a.5.5 0 0 1 .356-.612ZM18.935.392a1.9 1.9 0 0 1 1.89 1.748l.005.148v13.073c0 .995-.772 1.815-1.747 1.89l-.148.006H1.896a1.9 1.9 0 0 1-1.89-1.748L0 15.361V2.288A1.9 1.9 0 0 1 1.748.398l.148-.006h17.039Zm-4.786 8.071a1.206 1.206 0 0 0-.87.306l-.097.097-3.457 3.862a.504.504 0 0 1-.665.072l-.062-.053-1.737-1.745a1.221 1.221 0 0 0-1.541-.146l-.108.081L1 14.862v.5c0 .455.343.833.784.888l.112.007h17.039c.44 0 .801-.322.873-.743l.01-.108-4.753-6.452a1.208 1.208 0 0 0-.916-.49Zm4.786-7.07H1.896a.897.897 0 0 0-.889.783L1 2.288V13.55l3.967-3.376a2.22 2.22 0 0 1 2.866-.002l.134.122 1.366 1.373 3.105-3.469a2.201 2.201 0 0 1 1.76-.732c.606.03 1.166.302 1.56.755l.112.141 3.96 5.374V2.288a.896.896 0 0 0-.895-.896Zm-12.2 2.784a2.09 2.09 0 0 1 0 2.95 2.08 2.08 0 0 1-1.476.61 2.083 2.083 0 0 1-1.475-.61 2.088 2.088 0 0 1 0-2.95 2.09 2.09 0 0 1 2.95 0Zm-1.475.389a1.088 1.088 0 1 0 .768 1.855 1.09 1.09 0 0 0 0-1.537 1.084 1.084 0 0 0-.768-.318Z",
    clipRule: "evenodd"
  })]
});